import { Component, inject, OnInit, Signal } from '@angular/core';
import { StripeComponent } from '../stripe/stripe.component';
import { Store } from '@ngxs/store';
import { CartState } from '../../state/cart.state';
import { AsyncPipe, CurrencyPipe, SlicePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CartActions } from '../../state/cart.actions';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { FormShippingSelectComponent } from '../form-shipping-select/form-shipping-select.component';
import { FormShippingUserComponent } from '../form-shipping-user/form-shipping-user.component';
import { EnviaService } from '../../service/envia.service';
import { FormPaymentStripeComponent } from '../form-payment-stripe/form-payment-stripe.component';
import { StripeServiceAngular } from '../../service/stripe.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { faTrash, faCircle } from '@fortawesome/pro-solid-svg-icons';

import { faX, faFlag } from '@fortawesome/pro-regular-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-checkout-modal',
  imports: [StripeComponent, CurrencyPipe, SlicePipe, AsyncPipe, FormShippingUserComponent, FormShippingSelectComponent, FormPaymentStripeComponent, FontAwesomeModule],
  templateUrl: './checkout-modal.component.html',
  styleUrl: './checkout-modal.component.scss',
  standalone: true
})
export class CheckoutModalComponent implements OnInit {
  // !corregir el error del calculo del precio total de los productos
  private readonly gaService = inject(GoogleAnalyticsService);
  private modalService = inject(NgbModal);
  iconSpinner = faSpinner;
  iconTrash = faTrash;
  list: Observable<any> = new Observable<any>();
  priceShipping: any;
  priceTotal: number = 0;
  priceSubtotal: number = 0;
  validatePaymenSuccess = false;

  shippingEnable = true;
  rateEnable = false;
  stripeEnable = false;
  enableLoading = false;

  listNameProduct = '';
  listproduct: string[] = [];

  dataUser: any = {};
  datashipping = {};
  dataRate: any = {};

  amountTotal: any = '';

  rate: any;

  isDelete = true;

  message
  loadingToken = false;
  successPaymentMessage = false;
  erroStripe = false;


  constructor(
    private store: Store,
    private enviaServices: EnviaService,
    private stripeService: StripeServiceAngular,
    private icon: FaIconLibrary
  ) {
    icon.addIcons(faX, faCircle, faFlag);
    this.store.select(CartState.getShipping).subscribe((res) => {
      this.priceTotal += res;
      this.priceShipping = res;

    });

    this.list = this.store.select(CartState.getList);
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.


    this.list.subscribe((res) => {

      this.priceTotal = 0;
      this.priceSubtotal = 0;

      res.forEach((element) => {
        this.priceSubtotal += element.price * element.stock;
        this.priceTotal = this.priceSubtotal;
      });
    });

    this.store.select(CartState.getList).subscribe((res) => {
      res.forEach((element) => {
        this.amountTotal = +this.amountTotal
        this.amountTotal += +element.price * +element.stock;
        this.listNameProduct += `${element.name}, `;
        this.listproduct.push(element);
        
      });

    });

    this.gaService.pageView(`/checkout`, {
      title: `Popup Checkout Etoy Republic`,
    });
  }
  closeModal() {
    this.modalService.dismissAll();
  }
  validations(event) {
    this.validatePaymenSuccess = event;
  }
  deleteProduct(id) {
    this.priceTotal = 0;
    this.priceSubtotal = 0;
    this.store.dispatch(new CartActions.Delete(id));
  }
  validationDelete(event) {
    this.isDelete = event;
  }
  shipping(event) {
    
    this.enableLoading = true;
    this.shippingEnable = false;

    this.dataUser = event;
    this.enviaServices.getShippingRates(event).subscribe((res) => {
      
      if (res.body?.meta === 'error') {
        res.body.error.message = 'Lo sentimos, no podemos calcular tu envió en este momento, intenta más tarde.'
        this.rate = res.body;
        this.rateEnable = true;

        this.enableLoading = false;
        return false;
      }

      this.rate = res?.body;
      this.rateEnable = true;

      this.enableLoading = false;
      return true;
      // this.isLoad = false;

      // this.listRate = res?.body?.data;
    });
  }
  rateSelected(event) {
    

    const preShippingCost = +Math.round(event.totalPrice * 1.05);
    this.amountTotal += Math.round(event.totalPrice * 1.05);
    


    if (Number.isInteger(preShippingCost)) {
      this.amountTotal = this.amountTotal.toString() + '00';
    } else {
      const split = this.amountTotal.toString().split('.');
      
      let decimal = '';
      if (split[1].length === 1) {
        decimal = `0${split[1]}`;
      } else {
        decimal = split[1];
      }

      this.amountTotal = `${split[0]}${decimal}`;
    }
    this.rateEnable = false;
    this.stripeEnable = true;
    this.dataRate = event;

    this.store.dispatch(new CartActions.SetShipping(+preShippingCost));
  }
  createPaymentIntent(_pm: string, amount: number) {
    Number(amount);
    // 
    // return false;
    this.stripeService
      .createPaymentIntent({ amount, description: this.listNameProduct, client: { customer_email: this.dataUser.destination.email, customer_name: `${this.dataUser.destination.first_name} ${this.dataUser.destination.last_name} ` } })
      .subscribe((res) => {
        // this.elementsOptions.clientSecret = res?.paymentIntent.client_secret!;

        const _pi = res.paymentIntent.id;

        localStorage.setItem('stripe_client', `${res?.paymentIntent.client_secret}`);
        this.store.dispatch(new CartActions.SetTokenStripe(res?.paymentIntent.client_secret!));
        //

        this.confirmPaymentIntent(_pm, _pi);
      });
  }
  confirmPaymentIntent(_pm, _pi) {
    const obj = {
      client: _pi,
      method: _pm,
      email: this.dataUser.destination.email,
      product: this.listproduct,
      user: this.dataUser.destination,
      rate: this.dataRate,
      shipping: this.dataUser.destination
    };

    this.stripeService.postConfirmIntentPayment(obj).subscribe(
      (res) => {

        this.gaService.event('payment', {
          category: 'success_payment',
          label: 'Payment',
        });

        this.message = res;
        this.loadingToken = false;
        if (res.success) {
          this.successPaymentMessage = true;
          this.erroStripe = false;
          this.store.dispatch(new CartActions.Reset());
          // this.isCompletePayment.emit(true);
        }
        if (res?.stripError!) {
          this.successPaymentMessage = false;
          this.erroStripe = true;
        }
      },
      (err) => {
        this.loadingToken = false;
        this.erroStripe = true;
      },
    );
  }
}
